import { motion } from "framer-motion";
import styled from "styled-components";

export const Slide = styled(motion.div)`
  flex-shrink: 0;
  height: 100%;
  width: auto;

  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  border: ${({ $isSelected }) => ($isSelected ? "3px solid #36f99f" : "none")};
  border-radius: 2px;

  cursor: pointer;
  transform-origin: center;
  transition: all 0.1s ease-in-out;
  &:hover {
    transform: ${({ $isSelected }) => (!$isSelected ? "scale(1.02)" : "none")};
  }
`;

export const ImageLoaderContainer = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  padding: 19.909px 20px 20.091px 20px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 5px;
  background: rgba(205, 211, 249, 0.5);
`;
